import { useShoppingBasketDefaultURLOnFailure } from '#src/clientState/hooks';
import {
  ErrorBoundary,
  useBrokenFlowModal,
} from '@edreamsodigeo/frontend-core';
import React, { useEffect } from 'react';

import { ErrorModal } from './ErrorModal';
import { reloadThePage } from './utils';

const RedirectToTheDefaultOnFailureURL = () => {
  const { onFailure } = useShoppingBasketDefaultURLOnFailure();

  useEffect(() => {
    onFailure();
  }, [onFailure]);

  return null;
};

export const ErrorModalWrapper = () => {
  const { close, isOpen } = useBrokenFlowModal();

  return <ErrorModal isOpen={isOpen} close={close} onRetry={reloadThePage} />;
};

export const ErrorModalWrapperWithError = () => {
  return (
    <ErrorBoundary
      name="error-modal-error-boundary"
      fallback={<RedirectToTheDefaultOnFailureURL />}
    >
      <ErrorModalWrapper />
    </ErrorBoundary>
  );
};
